export const useSearchNavigate = () => {
    const searchUrl = useSearchUrl();
    const route = useRoute();
    const getBaseRouteName = useRouteBaseName(); // strips language code from route name
    const { isExpired } = useSearchToken();
    const { public: publicConfig } = useRuntimeConfig();

    return function searchNavigate(query: string, manufacturerPath?: string) {
        const routeBaseName = getBaseRouteName(route);
        const isSearch = routeBaseName == "search-path";
        const tokenExpired = isExpired(publicConfig.searchTokenTtlMinutes);

        /* Navigate to search results with a full page refresh ("external") because search may do a redirect, and a 302
        is better for browser history in that case. On the search page itself a client-side navigation avoids
        discarding the heavy page context — unless the token has expired, in which case a full SSR reload is
        required so a fresh token is generated before any search request reaches the backend.
         */
        return navigateTo(searchUrl(query, manufacturerPath), { external: !isSearch || tokenExpired });
    };
};
